import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import Post from "./Post";
import { useEffect, useState } from "react";
import LoadingIndicator from "../Atomics/Loading/Loading";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { blogFetcher } from "../../api/requests";
import DOMPurify from "dompurify";

export default function SinglePost() {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const sanitizedContent = DOMPurify.sanitize(post?.content || "");

  const getPost = async () => {
    try {
      setLoading(true);

      const res = await blogFetcher.getEachPost(id);

      if (res) setPost(res);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPost();
  }, [id]);

  return (
    <>
      <Col md={12} style={{ marginTop: "20px" }}>
        <SectionHeader heading="" />
      </Col>

      <Col md={8} style={{ minHeight: "calc(100vh - 170px)" }}>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <Post
            postTitle={post?.title}
            publishedOn={post?.published_date}
            imgSrc={post?.cover_article}
            category={post?.category.name}
            viewCount={post?.counted_view}
            tags={""}
          >
            <p>{post?.summary}</p>
            <br />
            {/* <blockquote className="blockquote">
            <p className="mb-0">این متن نمایش دهنده یک نقل قول تست می باشد.</p>
            <footer className="blockquote-footer">
              هلیا بیگدلی از <cite title="Source Title">راسخون</cite>
            </footer>
          </blockquote> */}
            <p dangerouslySetInnerHTML={{ __html: sanitizedContent }}></p>
            <br />

            {/* <div className="gallery mb-4">
              <img
                className="rounded img-fluid"
                alt="Gallery Image 1"
                src="img/blog/2.png"
              />
              <img
                className="rounded img-fluid"
                alt="Gallery Image 2"
                src="img/blog/3.png"
              />
              <img
                className="rounded img-fluid"
                alt="Gallery Image 3"
                src="img/blog/1.png"
              />
            </div> */}

            <p style={{ whiteSpace: "pre-wrap" }}>{post?.result}</p>
          </Post>
        )}
      </Col>
    </>
  );
}
